import wrapper from 'wrapper';

let scrollPosition = 0;
let checkpoints = [100, 75, 50, 25]; // feel free to change those, make sure they are ordered large -> small

const trackScrollPosition = () => {
    const { scrollHeight } = wrapper.select('.bbc-news-vj-wrapper');
    const scrollTop = wrapper.getScrollPosition();
    if (scrollTop < scrollPosition) return;
    scrollPosition = scrollTop + 1.1 * window.innerHeight;
    const percentage = (100 * scrollPosition) / scrollHeight;

    // check if percentage passed a checkpoint
    const checkpointIndex = checkpoints.findIndex((cp) => cp <= percentage);
    if (checkpointIndex === -1) {
        return;
    }
    const checkpointsToTrack = checkpoints.slice(checkpointIndex); // e.g. when we got index=1 we'll track 75, 50, 25 (if 50 & 25 haven't been removed)
    checkpointsToTrack.forEach((checkpoint) => wrapper.trackBackgroundEvent('Reader scroll position', `${checkpoint}%`));

    // remove checkpoints that are already tracked so we won't get double tracking
    checkpoints = checkpoints.slice(0, checkpointIndex);
};

export default trackScrollPosition;
